import { EChartsOption } from 'echarts';

export const renewalOverTimeConfig: EChartsOption = {
	grid: {
		left: '3%',
		right: '4%',
		bottom: '3%',
		containLabel: true,
	},
	tooltip: {
		trigger: 'axis',
		backgroundColor: '#6a7985',
		textStyle: {
			color: 'white',
		},
		borderWidth: 0,
		padding: 8,
		formatter: (params: any) => '',
		axisPointer: {
			type: 'line',
			lineStyle: {
				color: '#5d78ff',
				width: 1,
				type: 'dashed',
			},
			crossStyle: {
				color: '#1e90ff',
				width: 1,
				type: 'dashed',
			},
		},
	},
	legend: {
		data: ['Linux on-demand potential savings', 'Expiring commitments potential savings'],
		left: '3%',
		icon: 'roundRect',
	},
	color: ['#9FA8DA', '#90CAF9'],
	xAxis: [
		{
			type: 'category',
			boundaryGap: false,
		},
	],
	yAxis: [
		{
			type: 'value',
			axisLabel: {
				formatter: '${value}',
			},
			axisTick: {
				show: true,
			},
			show: true,
			min: '0',
			axisLine: {
				show: true,
				lineStyle: {
					color: '#333',
					width: 1,
				},
			},
			splitLine: {
				show: true,
				lineStyle: {
					color: '#989898',
					type: 'solid',
					width: 0.5,
				},
			},
		},
	],
	series: [],
	animationEasing: 'elasticOut',
	animationDelayUpdate: (idx) => idx * 5,
};
